import { createAction } from '@reduxjs/toolkit';
import { getPayloadCreator } from '../core/actionHelpers';

export const SANITIZE = 'SANITIZE';
export type SanitizeAction = { type: typeof SANITIZE; payload: undefined };
export const sanitize = createAction(SANITIZE);
export const SET_ROOT = 'SET_ROOT';
export const setRoot = createAction(SET_ROOT);
export const PERSIST_DATA_LOAD_COMPLETE = 'PERSIST_DATA_LOAD_COMPLETE';
export type PersistAction = { type: typeof PERSIST_DATA_LOAD_COMPLETE; payload: undefined };
export const persistDataLoadComplete = createAction(PERSIST_DATA_LOAD_COMPLETE);
export const SET_UPDATE_ALL_STATE = 'SET_UPDATE_ALL_STATE';
export const setUpdateAllState = createAction(SET_UPDATE_ALL_STATE, getPayloadCreator<any>());
